import axios from "@/utils/axiosHelper";
// 初始化数据
export const onGetInitDataAPI = params => {
  return axios(
    { url: "/cherry/shakin/init", method: "GET", params },
    { interceptResultCode: false }
  );
};

// 抽奖
export const onDraw = params => {
  return axios(
    { url: "/cherry/shakin/draw", method: "post", params },
    { interceptResultCode: false }
  );
};

// 签到
export const onSign = params => {
  return axios(
    { url: "/cherry/shakin/sign", method: "GET", params },
    { interceptResultCode: false }
  );
};

// 兑换奖励
export const onGetRewardOnBag = params => {
  return axios(
    { url: "/cherry/shakin/exchange", method: "post", params },
    { interceptResultCode: false }
  );
};

// 奖励领取
export const onGetReward = params => {
  return axios(
    { url: "/cherry/shakin/receive", method: "GET", params },
    { interceptResultCode: false }
  );
};

// 地址填写
export const onSubmitAddress = params => {
  return axios(
    { url: "/cherry/shakin/address", method: "post", params },
    { interceptResultCode: false }
  );
};

// 助力
export const onHelp = params => {
  return axios(
    { url: "/cherry/shakin/share", method: "get", params },
    { interceptResultCode: false }
  );
};

// 免密登录
export const secretFreeLoginApi = params => {
  return axios(
    { url: "/game/clock/login", method: "POST", params },
    { interceptResultCode: false }
  );
};



// WEBPACK FOOTER //
// ./src/pages/sakura/sheep/api.js